import {connect} from "redux-vue";
import ModalTemplate from "./ModalTemplate";
import * as locationActions from "../actions/location";
import * as stakeholderActions from "../actions/stakeholder";
import {testStakeholderIsStaff} from "../helpers/tools";
import { Skeleton, SkeletonTheme } from 'vue-loading-skeleton';


const LocationModal = {
  props: ['location', 'stakeholder','setLocation', 'setStakeholder', 'fetchStakeholder', 'fetchLocation'],

  watch: {
    'location.model'(val, prev) {
      if (val !== prev) {
        this.fetchData();
      }
    },
    'stakeholder.model'(val, prev) {
      if (val !== prev) {
        this.fetchData();
      }
    },
    'location.detailsHTML'(val, prev) {
      if (val !== prev) {
        this.$nextTick(() => {
          tippy('[data-tippy-content]', {
            placement: 'bottom'
          });
        })
      }
    },
    'stakeholder.detailsHTML'(val, prev) {
      if (val !== prev) {
        this.$nextTick(() => {
          tippy('[data-tippy-content]', {
            placement: 'bottom'
          });
        })
      }
    }
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    /**
     *
     */
    fetchData() {
      if (this.stakeholder.model) {
        this.fetchStakeholder(this.stakeholder.model);
      } else if (this.location.model) {
        this.fetchLocation(this.location.model);
      }
    },

    /**
     *
     * @param stakeholder
     * @returns {Function}
     */
    handleStakeholder(stakeholder) {
      return () => {
        if (stakeholder && this.stakeholder.model && stakeholder.id === this.stakeholder.model.id) return;
        this.setStakeholder(stakeholder);
      }
    },

    /**
     *
     */
    handleClose() {
      this.setLocation(null);
      this.setStakeholder(null);
    }
  },

  /**
   *
   * @param h
   * @returns {*}
   */
  render(h) {
    if (this.location.model) {
      const detailsHTML = this.stakeholder.detailsHTML || this.location.detailsHTML;
      const loading = this.stakeholder.model && (
        <div class="flex-1 overflow-y-auto p-6">
          <div class="w-full lg:w-10/12 mx-auto flex flex-col justify-center">
            <div class="flex flex-col lg:flex-row">
              <div class={(testStakeholderIsStaff(this.stakeholder.model) ? 'lg:w-1/2' : 'lg:w-1/3') + ' py-12 relative'}>
                {testStakeholderIsStaff(this.stakeholder.model) && (
                  <div class="sticky top-0">
                    <div class="flex items-center">
                      <img src={this.stakeholder.model.img} alt="" class="w-32 lg:w-40 mt-6"/>
                      <ul class="text-xs pl-2 transform translate-y-3">
                        <li class="mb-2">
                          <div class="bg-white rounded-full p-px border-white border w-24 lg:w-40">
                            <div class="bg-brand-orange-500 rounded-full p-1 border-2 border-brand-orange-500"
                                 style={`width: ${this.stakeholder.model.motivation}%`}>
                            </div>
                          </div>
                          <p class="px-2 py-px">
                            Motivation: {this.stakeholder.model.motivation}%
                          </p>
                        </li>
                        <li>
                          <div class="bg-white rounded-full p-px border-white border w-24 lg:w-40">
                            <div class="bg-brand-teal-500 rounded-full p-1 border-2 border-brand-teal-500"
                                 style={`width: ${this.stakeholder.model.ability}%`}>
                            </div>
                          </div>
                          <p class="px-2 py-px">
                            Abilities: {this.stakeholder.model.ability}%
                          </p>
                        </li>
                      </ul>
                    </div>
                    <p class="text-lg lg:text-2xl font-bold my-2">
                      {this.location.model.id === "DHT"
                        ? this.stakeholder.model.title
                        : this.location.model.name + " " + this.stakeholder.model.title
                      }
                    </p>
                  </div>
                )}
                {testStakeholderIsStaff(this.stakeholder.model) || (
                  <div class="sticky top-0">
                    <div class="flex flex-col items-center w-32 lg:w-40">
                      <img src={this.stakeholder.model.img} alt="" class="w-full mt-6"/>
                      <p class="text-lg lg:text-2xl font-bold my-2">
                        {this.location.model.name}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div class={(testStakeholderIsStaff(this.stakeholder.model) ? 'lg:w-1/2' : 'lg:w-2/3') + ' overflow-y-auto py-12'}>
                <SkeletonTheme color="#d5d5d5" highlight="#ddd" duration={0.5}>
                  <Skeleton width="45%" height="30px" />
                  <div class="h-4"></div>
                  <Skeleton height="12px" width="70%" />
                  <Skeleton height="12px" width="75%" />
                  <Skeleton height="12px" width="45%" />
                </SkeletonTheme>
                <div class="h-20"></div>
                <SkeletonTheme color="#d5d5d5" highlight="#ddd" duration={0.5}>
                  <Skeleton width="45%" height="30px" />
                  <div class="h-4"></div>
                  <Skeleton height="12px" width="70%" />
                  <Skeleton height="12px" width="75%" />
                  <Skeleton height="12px" width="45%" />
                </SkeletonTheme>
              </div>
            </div>
          </div>
        </div>
      );

      return (
        <ModalTemplate>
          <div class="bg-gray-200 rounded overflow-y-hidden flex flex-col relative" style="max-height: 35rem;">
            <div class="flex items-center justify-end absolute top-0 left-0 w-full p-3">
              <button type="button" onClick={this.handleClose}
                      class="rounded-full bg-brand-green-400 p-5 py-1 text-white uppercase text-sm font-bold focus:outline-none relative z-20">
                Close
              </button>
            </div>
            {detailsHTML
              ? <div domPropsInnerHTML={detailsHTML} class="flex-1 overflow-y-auto p-6"/>
              : loading
            }
          </div>
        </ModalTemplate>
      );
    }
    return null;
  }
};

function mapStateToProps(state) {
  return {
    location: state.simulation.location,
    stakeholder: state.simulation.stakeholder,
  };
}

function mapActionToProps(dispatch) {
  return {
    setLocation: (location) => dispatch(locationActions.setLocation(location)),
    fetchLocation: (location) => dispatch(locationActions.fetchLocation(location)),
    setStakeholder: (stakeholder) => dispatch(stakeholderActions.setStakeholder(stakeholder)),
    fetchStakeholder: (stakeholder) => dispatch(stakeholderActions.fetchStakeholder(stakeholder)),
  };
}

export default connect(mapStateToProps, mapActionToProps)(LocationModal);
